export { sendGTMEvent as sendGtmEvent } from '@next/third-parties/google';
